import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import authService from '../../../Services/authService';


const HealthConcerns = () => {

  const [Categories, setCategories] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    // Load organizations
    loadCategories();
  }, []);

  const loadCategories = () => {

    const url = new URL(authService.getApiUrl() + 'categorylist');

    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        setCategories(result.data || []);
        //setFormData(data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  // const categories = [
  //   {
  //     name: "Full Body Checkups",
  //     alt: "Doctor checking patient's blood pressure",
  //     bgColor: "bg-white",
  //     image: "/images/full-body-checkup.webp",
  //   },
  //   {
  //     name: "Heart",
  //     alt: "Heart in hands",
  //     bgColor: "bg-white",
  //   },
  //   {
  //     name: "Diabetes",
  //     alt: "Glucose meter",
  //     bgColor: "bg-white",
  //   },
  //   {
  //     name: "Fever & Infection",
  //     alt: "Thermometer",
  //     bgColor: "bg-white",
  //   },
  //   {
  //     name: "Allergy Panels",
  //     alt: "Person with allergies",
  //     bgColor: "bg-white",
  //   },
  //   {
  //     name: "Thyroid",
  //     alt: "Person touching neck/thyroid area",
  //     bgColor: "bg-white",
  //   },
  //   {
  //     name: "Cancer",
  //     alt: "Cancer awareness ribbon",
  //     bgColor: "bg-white",
  //   },
  //   {
  //     name: "Hair & Skin",
  //     alt: "Hair and skin care",
  //     bgColor: "bg-white",
  //   },
  // ];

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };


  return (
    <section className="py-10 md:py-14 bg-[#F5F5F7]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-semibold text-[#4A4A4A] mb-2">
            Browse by <span className="text-[#951C25]">Health Concerns</span>
          </h2>
          <p className="text-[#4A4A4A]/70 max-w-2xl mx-auto">
            Vithyou provides screening to detect potential health disorders. Find your screening test based on your health concerns.
          </p>
        </div>

        <div className="relative">
          {/* Add `overflow-x-hidden` on the parent container */}
          <div ref={scrollRef} className="flex overflow-x-auto pb-6 -mx-4 px-4 space-x-3 scrollbar-hide">

            {Categories && Categories.length > 0 && Categories.map((category, index) => (
              <Link
                to={'/' + encodeURIComponent(category.category_name.replace(/ /g, '-'))}
              >
                <div
                  key={index}
                  className={`flex-shrink-0 w-[140px] h-[160px] rounded-2xl border border-[#E0E0E0] bg-white p-4 flex flex-col justify-between hover:shadow-sm transition-shadow cursor-pointer overflow-hidden relative group hover:border-[#951C25]/30`}
                >
                  <div className="absolute inset-0 flex items-center justify-center  ">
                    <div className="relative w-full h-full">
                      {category.image ? (
                        <img
                          className="object-cover w-full h-full" src={authService.getApiDomainUrl() + category.image || "/placeholder.svg"} title={category.image} alt={category.image}
                        />
                      ) : (
                        <div className="bg-gradient-to-br from-[#951C25]/5 to-transparent w-full h-full"></div>
                      )}
                    </div>
                  </div>

                  {/* <div className="relative z-10">
                    <div className="w-8 h-8 rounded-full bg-[#F5F5F7]/70 backdrop-blur-sm flex items-center justify-center mb-2 border border-[#951C25]/20">
                      {category.image ? (
                        <div className="relative w-5 h-5">
                          <img
                            src={authService.getApiDomainUrl() + category.image || "/placeholder.svg" } title={category.image} alt={category.image}

                            className="object-cover rounded-full w-full h-full"
                          />
                        </div>
                      ) : (
                        category.icon
                      )}
                    </div>
                  </div> */}

                  <div className="relative z-10">
                    <h2 className="text-base font-medium text-[#4A4A4A]">{category.category_name}</h2>
                    {/* <p className="text-xs text-[#951C25] mt-1">View tests</p> */}
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Left Button */}
          <div className="absolute left-0 top-1/2 -translate-y-1/2  from-[#F5F5F7] w-12 h-full flex items-center justify-start">
            <button
              onClick={scrollLeft}
              className="w-8 h-8 rounded-full bg-white border border-[#E0E0E0] flex items-center justify-center text-[#951C25] shadow-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
          </div>

          {/* Right Button */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2  from-[#F5F5F7] w-12 h-full flex items-center justify-end">
            <button
              onClick={scrollRight}
              className="w-8 h-8 rounded-full bg-white border border-[#E0E0E0] flex items-center justify-center text-[#951C25]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HealthConcerns;
